import { useSetRecoilState } from "recoil";
import { toastsAtom } from "../../common/miscellaneous/toastsAtom";

export function useSetToastsState() {
  return useSetRecoilState(toastsAtom);
}
